import { SectionTitle } from "@/components/molecules";
import { PageContainer } from "@/components/organisms";
import { MapIcon } from "@/assets/svgIcons/MapIcon";
import { COLOR_CODE } from "@/utils/constants/colors";
import {formatAddress} from '@/helpers/shadcn/utils'

const Section = ({id, title}) => {
  return <SectionTitle id={id} label={title} />
}

const InfoItem = ({label, value, isHighlighted}) => (
  <div className="col-span-1 pt-4">
    <span className="key text-sm" style={{color: COLOR_CODE._D0D0D0}}>
      {label}
    </span>
    <h2 className="val text-base font-bold" style={isHighlighted ? {color: COLOR_CODE._3387DF} : {}}>
      {value !== undefined && value !== null && value !== '' ? value : '-'}
    </h2>
  </div>
)

const DisplayInformation = ({orderDetails}) => {
  const sections = [
    {
      id: 'general_info',
      title: 'General Information',
      items: [
        {label: 'Store ID', value: orderDetails?.storeId, isHighlighted: true},
        {label: 'Customer Name', value: orderDetails?.customerName},
        {label: 'Nickname', value: orderDetails?.nickname},
        {label: 'Store Name', value: orderDetails?.storeName},
        {label: 'Customer Uniq ID', value: orderDetails?.customerUniqId},
        {label: 'ID Number', value: orderDetails?.idNumber},
      ],
    },
    {
      id: 'address_info',
      title: null, // No title for this section
      items: [],
      mainItems: {
        label: 'Address',
        value: orderDetails?.address || '-',
        customComponent: (
          <div className="flex items-center gap-2 pl-4">
            <MapIcon />
            <h2 className="val text-base font-semibold"> {formatAddress(orderDetails?.address)}</h2>
          </div>
        ),
      },
    },
    {
      id: 'additional_info',
      title: null, // No title for this section
      items: [
        {label: 'Parent Member ID', value: orderDetails?.parentMemberId},
        {label: 'Locate', value: orderDetails?.locate},
        {label: 'EDO Flag', value: orderDetails?.edoFlag},
      ],
    },
    {
      id: 'location_info',
      title: 'Customer and Location Details',
      items: [
        {label: 'Order Location ID', value: orderDetails?.orderLocationId},
        {label: 'Customer GTMU', value: orderDetails?.customerGTMU},
        {label: 'Country ISO Code', value: orderDetails?.countryIsoCode},
      ],
    },
  ]

  return (
    <>
      {sections.map(section => (
        <div key={section.id} className="order-overview">
          {section.title && (
            <div className="sc-border grid pl-4">
              <Section id={section.id} title={section.title} />
            </div>
          )}
          {section.mainItems && <div className="sc-border grid pb-3 pt-3">{section.mainItems.customComponent}</div>}
          <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
            {section.items.map(item => (
              <InfoItem key={item.label} label={item.label} value={item.value} isHighlighted={item.isHighlighted} />
            ))}
          </div>
        </div>
      ))}
    </>
  )
}

const OrderSoldToPage = ({ OrderDetails }) => {
  return (
    <PageContainer>
      <DisplayInformation orderDetails={OrderDetails} />
    </PageContainer>
  );
};

export default OrderSoldToPage;